import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./KeywordMarquee.css";

const KEYWORD_KEYS = [
  "home.keywordMarquee.littleJoys",
  "home.keywordMarquee.gratitude",
  "home.keywordMarquee.happinessSavings",
  "home.keywordMarquee.proudMoments",
  "home.keywordMarquee.foodieLife",
  "home.keywordMarquee.travelSnapshots",
  "home.keywordMarquee.petsAndMe",
  "home.keywordMarquee.specialJournal",
  "home.keywordMarquee.cherishedAnniversaries",
  "home.keywordMarquee.freeNotes",
  "home.keywordMarquee.sorrowHealingRoom",
  "home.keywordMarquee.regrets",
  "home.keywordMarquee.secretBase",
  "home.keywordMarquee.legacyOfLove",
  "home.keywordMarquee.finalChapter",
  "home.keywordMarquee.lifeSummary",
  "home.keywordMarquee.wordsForYou",
];

interface KeywordGroupProps {
  keys: string[];
}

const KeywordGroup: React.FC<KeywordGroupProps> = ({ keys }) => {
  const { t } = useTranslation();

  return (
    <span className="keyword-marquee__group">
      {keys.map((key) => (
        <span className="keyword-marquee__keyword" key={key}>
          {t(key)}
        </span>
      ))}
    </span>
  );
};

const KeywordMarquee: React.FC = () => {
  const { t } = useTranslation();
  const [isPaused, setIsPaused] = useState(false);

  return (
    <button
      type="button"
      className="keyword-marquee"
      data-paused={isPaused ? "true" : "false"}
      aria-pressed={isPaused}
      aria-label={t(
        isPaused
          ? "home.keywordMarquee.resumeLabel"
          : "home.keywordMarquee.pauseLabel"
      )}
      onClick={() => setIsPaused((current) => !current)}
    >
      <span className="keyword-marquee__track" aria-hidden="true">
        <KeywordGroup keys={KEYWORD_KEYS} />
        <KeywordGroup keys={KEYWORD_KEYS} />
      </span>
    </button>
  );
};

export default KeywordMarquee;
